// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"d826e062","193":"0aa3199b","354":"1d7b709c","566":"9cf0ee5c","741":"fba785d6","799":"77b1bc9a"}[chunkId] + ".chunk.css";
};